async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();

    const moneyEl = document.querySelector('.cartCount .money');
    if (!moneyEl) return;

    const hiddenLabel = moneyEl.querySelector('.tif-visually-hidden');

    moneyEl.textContent = cart.item_count + ' ';
    if (hiddenLabel) {
      moneyEl.appendChild(hiddenLabel);
    }
  } catch (err) {
    console.error('Could not update cart count:', err);
  }
}

function formatMoney(cents) {
  const value = Number(cents);
  if (Number.isNaN(value)) return '';
  return (value / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'gbp',
  });
}

// Scoped to a single quick-buy form, so this works correctly even when
// several quick-buy dialogs exist on the same page at once (one per
// product on a collection grid).
function initVariantSelector(form) {
  const variantImages = form.querySelectorAll('.variant-images_img[role="option"]');
  if (!variantImages.length) return;

  const idField = form.querySelector('.product-id-field');
  const titleEl = form.querySelector('.variant-title');
  const priceEl = form.querySelector('.product-price');

  function handleVariantChange(el) {
    variantImages.forEach(function (img) {
      img.classList.remove('variant-selected');
      img.setAttribute('aria-selected', 'false');
    });
    el.classList.add('variant-selected');
    el.setAttribute('aria-selected', 'true');

    console.log(el)
    if (idField) idField.value = el.id;
    if (titleEl) {
      const strong = titleEl.querySelector('strong');

      if (strong) {
        strong.textContent = el.getAttribute('data-variant-title');
      }
    }

    const price = el.getAttribute('data-price');
    if (priceEl && price) priceEl.textContent = formatMoney(price);
  }

  variantImages.forEach(function (img) {
    img.addEventListener('click', function () {
      handleVariantChange(this);
    });
    img.addEventListener('keypress', function (e) {
      if (e.which === 13) this.click();
    });
  });
}

function initAjaxAddToCart(form) {
  let messageTimeout;
  const messageEl = form.querySelector('.form-message');

  const showMessage = (text, status) => {
    if (!messageEl) return;
    clearTimeout(messageTimeout);
    messageEl.textContent = text;
    messageEl.classList.add(`quickbuy-${status}`);
    messageTimeout = setTimeout(() => {
      messageEl.textContent = '';
      messageEl.classList.remove(`quickbuy-${status}`);
    }, 3000);
  };

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const formData = new FormData(this);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Could not add to cart');
      }

      showMessage('✓', 'success');
      updateCartCount();
    } catch (err) {
      showMessage(`couldn't add to cart`, 'fail');
      console.error(err);
    }
  });
}

document.querySelectorAll('.quick-buy').forEach(function (form) {
  initVariantSelector(form);
  initAjaxAddToCart(form);
});